export default __webpack_public_path__ + "static/media/7.cee50c0f.webp";